import React from 'react';

const Footer = () => {
    return (
        <div className='bg-neutral text-white'>
            <footer className="footer px-10 py-8">
                <div>
                    <span className="footer-title">Address</span>
                    <li className="list-none">North Mugda</li>
                    <li className="list-none">Dhaka, Bangladesh</li>
                </div>
                <div>
                    <span className="footer-title">Contact</span>
                    <li className="list-none">(+880) 1786270162</li>
                    <li className="list-none">shanto.sourav07@gmail.com</li>
                </div>
                <div>
                    <span className="footer-title">Links</span>
                    <a href='#about' className="link link-hover">About Me</a>
                    <a href='#skills' className="link link-hover">Skills</a>
                </div>
            </footer>
            <footer className="footer items-center justify-center px-4 py-8 border-y">
                <p>Copyright © 2022 - Sourav Saha - All Right Reserved</p>
            </footer>
        </div>
    );
};

export default Footer;